module.exports = __webpack_public_path__ + "img/ai-img-qxm.00f73e04.png";